import { h } from 'preact';
export const ArrowRight = () => (h("svg", { width: "7", height: "11", viewBox: "0 0 7 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    h("path", { d: "M1.23408 0.176783L6.18408 5.12678L1.23408 10.0768L0.352832 9.18928L4.41533 5.12678L0.352831 1.06428L1.23408 0.176783Z", fill: "#55676E", stroke: "#55676E", "stroke-width": "0.5" })));
